'use client';

type PageHeaderProps = {
  icon?: React.ReactNode;
  title: string;
  filters?: React.ReactNode;
  action?: React.ReactNode;
};

export default function PageHeader({
  icon,
  title,
  filters,
  action,
}: PageHeaderProps) {
  return (
    <div className="bg-white rounded-4   main-container min-h-15 w-full mb-3 ">
      <div className=" main-container p-3 flex flex-col md:content-center md:justify-center gap-2  ">
        <div className="flex flex-col md:flex-row  gap-2 justify-between md:items-center ">
          <h1 className="flex  items-center gap-1">
            <span className="text-el-blue-500 w-4.5 h-auto">
              {icon && icon}
            </span>
            <span className="text-24/[90%] font-bold ">{title}</span>
          </h1>
          {action && <div> {action}</div>}
        </div>
        {filters && (
          <div className="flex justify-between items-center">{filters}</div>
        )}
      </div>
    </div>
  );
}
